<template>
  <div>
    <fragment v-if="showCosts || quotationWithoutCosts">
      <HeaderCostQuotation :info="quotation" :show-info="false" />
      <QuotationSelectInsuranceCompany
        :value="insuranceCompany"
        @selected="updateInsuranceCompany"
        :info="quotation"
        @modal="showModalDetailsRefuseInsurance"
        @form="setCurrentFormDraftContract"
        :updated-form="currentFormDraftContract"
        @submit="editCostQuotation"
        @decline="submitDeclineCost"
        @draftForm="openModalAdd"
        :cost-updated-toggle="costUpdatedToggle"
        @remove="submitRemoveDraftContract"
        @reactivate="reactivateCostQuotation"
      >
        <ResumeQuotation
          :info="quotation"
          @changeView="viewEditQuotation"
          show-info
        />
        <BaseDataTableSection
          :show-button="quotation.acoes.critica.pode_registrar_critica"
          text-information="São pontos de desconformidade na cotação, na minuta ou na apólice que devem ser identificados e tratados para que as cotações e emissões ocorram corretamente."
        >
          <BaseDataTable
            :headers="headerCriticism"
            :items="[quotation.status_critica]"
            no-data-text="Nenhuma Crítica foi encontrada"
            hide-default-footer
            hide-default-header
            class="mb-7 table-header-end base__datatable--border"
          >
            <template v-slot:[`item.critica`]>
              <div class="font-weight-bold mb-2">
                <v-icon color="primary" size="13">
                  fa-exclamation-circle
                </v-icon>
                Crítica
              </div>
              <div>
                {{ quotation.quantidade_criticas_pendentes }} crítica(s)
                pendente(s)
              </div>
            </template>
            <template v-slot:[`item.chat`]>
              <div class="font-weight-bold mb-2">
                <v-icon color="primary" size="14"> far fa-comment </v-icon>
                Chat
              </div>
              <div>
                {{ quotation.quantidade_chats_abertos }} chat(s) aberto(s)
              </div>
            </template>
            <template v-slot:[`item.acoes`]>
              <BaseButton
                v-html="showVisualize"
                class="secondary"
                @click="redirectCriticism"
              />
            </template>
          </BaseDataTable>
        </BaseDataTableSection>
        <v-row class="mb-7">
          <v-col cols="12">
            <v-divider />
          </v-col>
        </v-row>
      </QuotationSelectInsuranceCompany>
      <BaseFooter>
        <v-row>
          <v-spacer />
          <v-col cols="12" sm="5" md="3" class="pb-5 pb-sm-0">
            <BaseButton
              v-html="'CANCELAR SOLICITAÇÃO'"
              class="white--text pink"
              width="100%"
              outlined
              @click="cancelQuotationButton"
            />
          </v-col>
          <v-col
            cols="12"
            sm="5"
            md="3"
            class="pl-0 pl-sm-5 pb-5 pb-sm-0"
            v-if="canRefuseDraftContractSelectedCost"
          >
            <BaseButton
              v-html="'RECUSAR MINUTA'"
              class="white--text pink"
              width="100%"
              @click="openModalRefuseDraftContract"
            />
          </v-col>
          <v-col
            cols="12"
            md="5"
            xl="4"
            class="pl-0 pl-sm-5 pb-5 pb-sm-0 pt-sm-5 pt-md-0"
            v-if="canRequestDraftContractSelectedCost"
          >
            <BaseButton
              v-html="'FORMALIZAR COTAÇÃO E SOLICITAR MINUTA'"
              class="white--text secondary"
              width="100%"
              @click="submitRequestDraftContract"
            />
          </v-col>
          <v-col
            cols="12"
            md="5"
            xl="4"
            class="pl-0 pl-sm-5 pb-5 pb-sm-0 pt-sm-5 pt-md-0"
            v-if="canApproveDraftContractSelectedCost"
          >
            <BaseButton
              v-html="'APROVAR MINUTA E SOLICITAR EMISSÃO'"
              class="white--text secondary"
              width="100%"
              @click="submitApproveDraftContract"
            />
          </v-col>
          <v-col
            cols="12"
            sm="5"
            xl="3"
            class="pl-0 pl-sm-5 pb-5 pb-sm-0"
            v-if="canRequestApprovalDraftContractSelectedCost"
          >
            <BaseButton
              v-html="'SOLICITAR APROVAÇÃO MINUTA'"
              class="white--text secondary"
              width="100%"
              @click="submitRequestApproveDraftContract"
            />
          </v-col>
          <!-- <v-col
            cols="12"
            sm="5"
            md="3"
            class="pl-0 pl-sm-5 pb-5 pb-sm-0"
            v-if="showChoiceCost"
          >
            <BaseButton
              v-html="'SOLICITAR COTAÇÃO'"
              class="white--text secondary"
              width="100%"
              @click="updateCostInQuotation"
            />
          </v-col> -->
        </v-row>
      </BaseFooter>
      <ModalCancelJustification
        v-model="modalCancel"
        @close="closeModalCancelQuotation"
      />
      <ModalCancelQuotation
        @close="closeModalCancelQuotation"
      
      />
      <ModalDetailsRefuseInsurance
        v-model="modalDetailsRefuseInsurance"
        @close="closeModalDetailsRefuseInsurance"
        :item="itemDetailsRefuseInsurance"
        v-if="itemDetailsRefuseInsurance"
      />
      <ModalRefuseDraftContractQuotation
        v-model="modalRefuse"
        @close="closeModalRefuseDraftContract"
        @submit="submitRefuseDraftContract"
      />
      <ModalAddDraftContract
        v-if="modalAdd"
        v-model="modalAdd"
        @close="closeModalAdd"
        :item="formToModalDraftContract"
        @submit="setCurrentFormDraftContract"
        :quotation="quotation"
      />
      <ModalDetailsInsuranceCostQuotation
        v-model="modalInsuranceDetailsCost"
        @close="closeInsuranceDetailsCost"
        @submit="submitRequestDraftContract"
      />
      <ModalUpdateDraftContract
        v-if="modalUpdate"
        v-model="modalUpdate"
        :cancel-button="false"
        :item="{}"
        @submit="closeModalUpdate"
        :quotation="quotation"
      />
      <ModalChangedCost
        v-model="modalChangedCost"
        @close="closeModalChangedCost"
        has-cancel-button
        title="Atualizar minuta"
        text="O custo foi alterado. Deseja atualizar a minuta?"
        text-button="SIM"
      />
    </fragment>
    <fragment v-else>
      <BaseDataTableSection
        title="MINUTA"
        name-button="INSERIR MINUTA"
        route-new-item="quotation new draft contract"
        v-if="hasDraftContract"
        :show-button="quotation.acoes.minuta.pode_inserir"
        text-information="É a prévia do documento de apólice, disponibilizado pelas seguradoras. Seu caráter é unicamente consultivo, não servindo como documento legal."
      >
        <BaseDataTable
          :headers="headerDraft"
          :items="[quotation.minuta]"
          no-data-text="Nenhuma Minuta foi encontrada"
          hide-default-footer
        >
          <template v-slot:[`item.nome`]="{}">
            {{ textDraftAccordingStatus }}
          </template>
          <template v-slot:[`item.arquivo.nome`]="{ item }">
            <div class="d-flex align-center">
              <v-icon class="pr-3" color="primary">
                fa-file
              </v-icon>
              {{ item.arquivo.nome }}
            </div>
          </template>
          <template v-slot:[`item.emitida_em`]="{ item }">
            <div v-if="item.emitida_em">
              {{ formatDateToDDMMYYYY(item.emitida_em) }}
            </div>
          </template>
          <template v-slot:[`item.validade_dias`]="{ item }">
            <div v-if="item.validade_dias">{{ item.validade_dias }} dias</div>
          </template>
          <template v-slot:[`item.valor`]="{ item }">
            <div v-if="item.valor">{{ asMoneyString(item.valor) }}</div>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-avatar :class="colorDraftStatus + ' mr-2'" size="30">
              <img :src="iconDrafStatus" class="base-quotation-status__img" />
            </v-avatar>
            {{ item.status.nome }}
            <BaseButton
              v-html="'VER'"
              @click="openModalDetailsRefuseDraft"
              text
              color="secondary"
              v-if="isRefusedDraft"
            />
          </template>
          <template v-slot:[`item.id`]="{ item }">
            <BaseButton
              color="secondary"
              class="base-quotation-status__button px-0 mr-2 mb-2"
              @click="previewItem(item)"
              v-if="hasItemDraft"
            >
              <img src="@/assets/ic_eye.svg" :alt="item.id" />
            </BaseButton>
            <BaseButton
              color="secondary"
              class="base-quotation-status__button px-0 mb-2"
              @click="editItem"
              :disabled="disabledButton"
            >
              <img src="@/assets/ic_edit.svg" :alt="item.id" />
            </BaseButton>
          </template>
        </BaseDataTable>
      </BaseDataTableSection>
      <BaseDataTableSection
        title="APÓLICE"
        :name-button="inserirApoliceTitulo"
        route-new-item="quotation new policy contract"
        v-if="hasPolicyContract"
        :show-button="quotation.acoes.apolice.pode_inserir || quotation.acoes.apolice.pode_sobrescrever_emissao"
        text-information="Documento emitido pela Seguradora que representa formalmente o contrato de Seguro Garantia."
      >
        <BaseDataTable
          :headers="headerPolicy"
          :items="[quotation.apolice]"
          hide-default-footer
          class="table-header-end"
        >
          <template v-slot:[`item.status_emissao.id`]="{ item }">
            <div v-if="hasPolicyContractFile(item)">
              Aguarde emissão da Seguradora
            </div>
          </template>
          <template v-slot:[`item.arquivo.nome`]="{ item }">
            <div class="d-flex align-center">
              <v-icon class="pr-3" color="primary">
                fa-file
              </v-icon>
              {{ item.arquivo.nome }}
            </div>
          </template>
          <template v-slot:[`item.status_emissao`]="{ item }">
            <v-avatar :class="colorPolicyStatus + ' mr-2'" size="30">
              <img :src="iconPolicyStatus" class="base-quotation-status__img" />
            </v-avatar>
            {{ item.status_emissao.nome }}
          </template>
          <template v-slot:[`item.emitida_em`]="{ item }">
            <div v-if="item.emitida_em">
              {{ formatDateToDDMMYYYY(item.emitida_em) }}
            </div>
          </template>
          <template v-slot:[`item.valor_premio`]="{ item }">
            <div v-if="item.valor_premio">
              {{ asMoneyString(item.valor_premio) }}
            </div>
          </template>
          <template v-slot:[`item.arquivo`]="{ item }">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <BaseButton
                  v-on="on"
                  color="secondary"
                  class="base-quotation-status__button px-0"
                  @click="previewItem(item)"
                  v-if="item.arquivo"
                >
                  <img src="@/assets/ic_eye.svg" :alt="item.id" />
                </BaseButton>
              </template>
              <span>Apólice</span>
            </v-tooltip>
            <!-- BOTÃO DE VISUALIZAR CERTIDÕES -->
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <BaseButton
                  style="margin-left:5px;"
                  v-on="on"
                  color="secondary"
                  class="base-quotation-status__button px-0"
                  @click="previewCertificates(item, 0)"
                  v-if="item.arquivo"
                >
                  <v-icon>
                    $vuetify.icons.fileCertificate
                  </v-icon>
                  1
                </BaseButton>
              </template>
              <span>Certidão Administradores</span>
            </v-tooltip>
            <!-- BOTÃO DE VISUALIZAR CERTIDÕES -->
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <BaseButton
                  style="margin-left:5px;"
                  v-on="on"
                  color="secondary"
                  class="base-quotation-status__button px-0"
                  @click="previewCertificates(item, 1)"
                  v-if="item.arquivo"
                >
                  <v-icon>
                    $vuetify.icons.fileCertificate
                  </v-icon>
                  2
                </BaseButton>
              </template>
              <span>Certidão Regularidade</span>
            </v-tooltip>
            <!-- BOTÃO DE VISUALIZAR REGISTRO SUSEP -->
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <BaseButton
                  style="margin-left:5px;"
                  v-on="on"
                  color="secondary"
                  class="base-quotation-status__button px-0"
                  @click="openRegistryWindow()"
                  v-if="item.arquivo"
                >
                  <v-icon>
                    $vuetify.icons.fileSigned
                  </v-icon>
                </BaseButton>
              </template>
              <span>Registro SUSEP</span>
            </v-tooltip>
          </template>
          <template v-slot:footer v-if="quotation.apolice.emitida_em">
            <v-row>
              <v-icon class="pl-4 pr-4 mb-3" small>
                fa-info
              </v-icon>
              <p
                class="caption darkBluishGray--text mt-1 mb-3 font-weight-medium details-policy__text-height"
              >
                Registro SUSEP – Extraído em até 7 dias úteis após a data de
                emissão da apólice, conforme Circular SUSEP 326 de 29/05/2006.
              </p>
            </v-row>
          </template>
        </BaseDataTable>
      </BaseDataTableSection>
      <v-row class="mt-8" v-if="hasBillsInPolicyContract">
        <v-col cols="12">
          <BaseDataTable
            :headers="headerBills"
            :items="quotation.apolice.boletos"
            no-data-text="Nenhum Boleto foi encontrado"
            hide-default-footer
            class="table-header-end"
          >
            <template v-slot:[`item.nome`]="{ item }">
              <div class="d-flex align-center">
                <v-icon class="pr-3" color="primary">
                  fa-file
                </v-icon>
                {{ item.nome }}
              </div>
            </template>
            <template v-slot:[`item.url`]="{ item }">
              <BaseButton
                color="secondary"
                class="base-quotation-status__button px-0"
                @click="previewItem(item)"
              >
                <img src="@/assets/ic_eye.svg" :alt="item.url" />
              </BaseButton>
            </template>
          </BaseDataTable>
        </v-col>
      </v-row>
      <BaseDataTableSection
        :show-button="quotation.acoes.critica.pode_registrar_critica"
        text-information="São pontos de desconformidade na cotação, na minuta ou na apólice que devem ser identificados e tratados para que as cotações e emissões ocorram corretamente."
      >
        <BaseDataTable
          :headers="headerCriticism"
          :items="[quotation.status_critica]"
          no-data-text="Nenhuma Crítica foi encontrada"
          hide-default-footer
          hide-default-header
          class="table-header-end base__datatable--border"
        >
          <template v-slot:[`item.critica`]>
            <div class="font-weight-bold mb-2">
              <v-icon color="primary" size="13"> fa-exclamation-circle </v-icon>
              Crítica
            </div>
            <div>
              {{ quotation.quantidade_criticas_pendentes }} crítica(s)
              pendente(s)
            </div>
          </template>
          <template v-slot:[`item.chat`]>
            <div class="font-weight-bold mb-2">
              <v-icon color="primary" size="14"> far fa-comment </v-icon>
              Chat
            </div>
            <div>
              {{ quotation.quantidade_chats_abertos }} chat(s) aberto(s)
            </div>
          </template>
          <template v-slot:[`item.acoes`]>
            <BaseButton
              v-html="showVisualize"
              class="secondary"
              @click="redirectCriticism"
            />
          </template>
        </BaseDataTable>
      </BaseDataTableSection>
      <DraftDisclaimer v-if="showDisclaimer" />
      <BaseFooter>
        <v-row>
          <v-col
            cols="12"
            sm="5"
            md="3"
            class="pb-5 pb-sm-0"
            v-if="showChangeInsuranceButton"
          >
            <BaseButton
              v-html="'TROCAR SEGURADORA'"
              color="pink"
              width="100%"
              outlined
              @click="changeViewToCost"
            />
          </v-col>
          <v-spacer />
          <v-col
            cols="12"
            sm="5"
            md="3"
            class="pr-sm-5"
            v-if="canRefuseDraftContractQuotation"
          >
            <BaseButton
              v-html="'RECUSAR MINUTA'"
              color="secondary"
              width="100%"
              outlined
              @click="openModal"
            />
          </v-col>
          <v-col cols="12" sm="5" md="3" v-if="showApproveButton">
            <BaseButton
              v-html="textButton"
              class="white--text secondary"
              width="100%"
              @click="submit"
            />
          </v-col>
        </v-row>
      </BaseFooter>
      <ModalRefuseDraftContract
        v-model="modal"
        @close="closeModal"
        @submit="submitRefuse"
      />
      <ModalDetailsRefuseDraftContract
        v-model="modalDetails"
        @close="closeModalDetails"
        :item="quotation"
        v-if="quotation.minuta"
      />
    </fragment>
    <ModalGenericCriticism
      v-model="modalGeneric"
      @close="closeModalGeneric"
      :title="titleGeneric"
      :text="textGeneric"
      :has-cancel-button="changeInsurance"
      :text-button="textButtonGeneric"
    />
    <ModalDetailsInsuranceQuotation
      v-model="modalInsuranceDetails"
      @close="closeInsuranceDetails"
      @submit="submitToInsurance"
    />
  </div>
</template>
<script>
import { api } from "@/api";
import DraftDisclaimer from "./DraftDisclaimer";
import ModalRefuseDraftContract from "../components/ModalRefuseDraftContract";
import ModalRefuseDraftContractQuotation from "../components/ModalRefuseDraftContract";
import ModalDetailsRefuseDraftContract from "../components/ModalDetailsRefuseDraftContract";
import HeaderCostQuotation from "../components/HeaderCostQuotation";
import ResumeQuotation from "../components/ResumeQuotation";
import QuotationSelectInsuranceCompany from "../components/QuotationSelectInsuranceCompany";
import ModalDetailsInsuranceQuotation from "../components/ModalDetailsInsuranceQuotation";
import { asMoneyString, formatDateToDDMMYYYY } from "@/utils/formats.js";
import ModalCancelQuotation from "../components/ModalCancelQuotation";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { mapActions } from "vuex";
import { FILE, documentAlreadyUploaded } from "@/mixins/DocumentsMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import _ from "lodash";
import ModalGenericCriticism from "../components/ModalGenericCriticism";
import ModalDetailsRefuseInsurance from "../components/ModalDetailsRefuseInsurance";
import ModalDetailsInsuranceMixin from "@/mixins/ModalDetailsInsuranceMixin";
import ModalAddDraftContract from "../components/ModalAddDraftContract";
import ModalDetailsInsuranceCostQuotation from "../components/ModalDetailsInsuranceQuotation";
import PermissionsCost from "@/mixins/PermissionsQuotationAccordingCostMixin";
import ModalUpdateDraftContract from "../components/ModalAddDraftContract";
import ModalChangedCost from "../components/ModalGenericCriticism";
import ModalCancelJustification from "../components/ModalCancelJustification";

const TABLE_HEADERS_CRITICISM = [
  { text: "Crítica", value: "critica", sortable: false },
  { text: "Chat", value: "chat", sortable: false },
  { text: "Ações", value: "acoes", sortable: false }
];
const TABLE_HEADERS_WITHOUT_DRAFT = [
  { text: "Arquivo", value: "nome", sortable: false },
  { text: "Status", value: "status", sortable: false },
  { text: "Ações", value: "id", sortable: false }
];
const TABLE_HEADERS_WITH_DRAFT = [
  { text: "Arquivo", value: "arquivo.nome", sortable: false },
  { text: "Número", value: "numero", sortable: false },
  { text: "Emissão", value: "emitida_em", sortable: false },
  { text: "Validade", value: "validade_dias", sortable: false },
  { text: "Custo", value: "valor", sortable: false },
  { text: "Status", value: "status", sortable: false },
  { text: "Ações", value: "id", sortable: false }
];
const TABLE_HEADERS_WITHOUT_POLICY = [
  { text: "Arquivo", value: "status_emissao.id", sortable: false },
  { text: "Status", value: "status_emissao", sortable: false }
];
const TABLE_HEADERS_WITH_POLICY = [
  { text: "Arquivo", value: "arquivo.nome", sortable: false },
  { text: "Emissão", value: "emitida_em", sortable: false },
  { text: "Custo", value: "valor_premio", sortable: false },
  { text: "Documentos", value: "arquivo", sortable: false }
];
const TABLE_HEADERS_BILLS = [
  { text: "Arquivo", value: "nome", sortable: false },
  { text: "Ações", value: "url", sortable: false }
];
const TABLE_HEADERS_BILLS_INVOICE = [
  { text: "Fatura", value: "nome", sortable: false },
  { text: "Ações", value: "url", sortable: false }
];
const TABLE_HEADERS_BILLS_TICKET = [
  { text: "Boleto", value: "nome", sortable: false },
  { text: "Ações", value: "url", sortable: false }
];
export default {
  data: () => ({
    loading: false,
    headerCriticism: TABLE_HEADERS_CRITICISM,
    headerDraft: TABLE_HEADERS_WITHOUT_DRAFT,
    headerPolicy: TABLE_HEADERS_WITHOUT_POLICY,
    headerBills: TABLE_HEADERS_BILLS,
    modal: false,
    modalDetails: false,
    showCosts: false,
    insuranceCompany: null,
    asMoneyString,
    formatDateToDDMMYYYY,
    titleGeneric: null,
    textGeneric: null,
    modalGeneric: false,
    modalCancel: false,
    isCancelQuotation: false,
    modalInsuranceDetails: false,
    changeInsurance: false,
    textButtonGeneric: "OK",
    modalRefuse: false,
    modalAdd: false,
    currentFormDraftContract: null,
    modalInsuranceDetailsCost: false,
    costUpdatedToggle: { toggle: false, insuranceCompanyId: "" },
    payloadEditCost: null,
    modalUpdate: false,
    modalChangedCost: false,
    formToModalDraftContract: null,
    statusPayload: null
  }),
  components: {
    DraftDisclaimer,
    ModalRefuseDraftContract,
    ModalDetailsRefuseDraftContract,
    HeaderCostQuotation,
    ResumeQuotation,
    QuotationSelectInsuranceCompany,
    ModalGenericCriticism,
    ModalCancelQuotation,
    ModalDetailsRefuseInsurance,
    ModalDetailsInsuranceQuotation,
    ModalRefuseDraftContractQuotation,
    ModalAddDraftContract,
    ModalDetailsInsuranceCostQuotation,
    ModalUpdateDraftContract,
    ModalChangedCost,
    ModalCancelJustification
  },
  created() {
    this.updateHeaders();
  },
  mixins: [
    LoadingRequest,
    DocumentsMixin,
    ModalDetailsInsuranceMixin,
    PermissionsCost
  ],
  computed: {
    showVisualize() {
      if (
        this.quotation.quantidade_criticas_pendentes == 0 &&
        this.quotation.quantidade_chats_abertos == 0
      ) {
        return "ADICIONAR";
      }

      return "VISUALIZAR";
    },
    colorCriticismStatus() {
      return this.quotation.status_critica.id == "sem_criticas"
        ? "toolbar-timeline__background-white"
        : this.quotation.status_critica.id == "pendente_regularizacao"
        ? "lightYellow"
        : this.quotation.status_critica.id == "regularizado"
        ? "green"
        : "pink";
    },
    isRefusedDraft() {
      return (
        this.quotation.minuta &&
        this.quotation.minuta.status.id == "minuta_recusada"
      );
    },
    quotationWithoutCosts() {
      if (this.quotation.status?.id == "cancelada") {
        return false;
      }

      if (this.currentStep?.id == "dados_processo" && !this.quotation.minuta) {
        return true;
      }

      if (
        this.currentStep?.id == "aguardando_cotacao" ||
        this.currentStep?.id == "solicitar_minuta"
      ) {
        return true;
      }

      // LSP-970, isso existe porque esse status aguardando_analise_minuta é o intermediário inventado.
      if (
        this.currentStep?.id == "aprovacao_minuta" &&
        this.quotation.status?.id == "aguardando_analise_minuta"
      ) {
        return true;
      }

      return false;
    },
    hasItemDraft() {
      return this.quotation.minuta && this.quotation.minuta.arquivo;
    },
    textDraftAccordingStatus() {
      return this.quotation.minuta.status.id == "minuta_solicitada"
        ? "Aguardando emissão de Minuta"
        : "Aguarde a resposta da Seguradora";
    },
    showDisclaimer() {
      return (
        this.currentStep &&
        (this.currentStep.id == "solicitar_minuta" ||
          this.currentStep.id == "aprovacao_minuta")
      );
    },
    disabledButton() {
      return (
        !this.quotation.acoes.processo.pode_editar_dados &&
        !this.quotation.acoes.minuta.pode_editar
      );
    },
    hasDraftContract() {
      return !this.hasPolicyContract && this.quotation.minuta;
    },
    hasPolicyContract() {
      return (
        (this.currentStep && this.currentStep.id == "emissao_apolice") ||
        this.quotation.passos.find(x => x.id == "apolice_emitida").status.id ==
          "realizado"
      );
    },
    showChoiceCost() {
      return this.currentStep.id == "dados_processo";
    },
    showChangeInsuranceButton() {
      return false;
      // return this.quotation.acoes.processo.pode_selecionar_seguradora;
    },
    currentStep() {
      return this.quotation.passos.find(
        x => x.status.id == "em_realizacao" || x.status.id == "cancelado"
      );
    },
    hasBillsInPolicyContract() {
      return (
        this.quotation.apolice &&
        this.hasPolicyContract &&
        this.quotation.apolice.boletos.length > 0
      );
    },
    textButton() {
      return this.quotation.acoes.minuta.pode_enviar_seguradora
        ? "ENVIAR PARA SEGURADORA"
        : this.quotation.acoes.minuta.pode_aprovar
        ? "APROVAR"
        : this.quotation.acoes.minuta.pode_solicitar_aprovacao
        ? "SOLICITAR APROVAÇÃO"
        : this.quotation.acoes.apolice.pode_enviar_seguradora
        ? "SOLICITAR APÓLICE"
        : "SOLICITAR APROVAÇÃO";
    },
    showApproveButton() {
      // Mais facil colocar os casos que não aparece o botão
      // que os casos que o botão aparece
      return !(
        !this.quotation.acoes.minuta.pode_aprovar &&
        !this.quotation.acoes.minuta.pode_enviar_seguradora &&
        !this.quotation.acoes.apolice.pode_enviar_seguradora
      );
    },
    colorDraftStatus() {
      return (
        ((this.quotation.minuta.status.id == "minuta_recusada" ||
          this.quotation.minuta.status.id == "minuta_declinada_seguradora") &&
          "pink") ||
        (this.quotation.minuta.status.id == "minuta_emitida" && "green") ||
        "lightYellow"
      );
    },
    colorPolicyStatus() {
      return (
        (this.quotation.apolice?.status_emissao?.id == "apolice_emitida" &&
          "green") ||
        "lightYellow"
      );
    },
    iconDrafStatus() {
      return (
        ((this.quotation.minuta.status.id == "minuta_recusada" ||
          this.quotation.minuta.status.id == "minuta_declinada_seguradora") &&
          require("@/assets/ic_close.svg")) ||
        (this.quotation.minuta.status.id == "minuta_emitida" &&
          require("@/assets/ic_check.svg")) ||
        require("@/assets/ic_wait.svg")
      );
    },
    iconPolicyStatus() {
      return (
        (this.quotation.apolice.status_emissao.id == "apolice_emitida" &&
          require("@/assets/ic_check.svg")) ||
        require("@/assets/ic_wait.svg")
      );
    },
    canRefuseDraftContractQuotation() {
      return this.quotation.acoes.minuta.pode_recusar;
    },
    inserirApoliceTitulo() {
      if(this.quotation.acoes.apolice.pode_inserir) {
        return "INSERIR APÓLICE";
      }
      else{
        return "CADASTRAR MANUALMENTE";
      }
    }
  },
  methods: {
    ...mapActions("quotation", [
      "requestApproveDraftContract",
      "requestRejectDraftContract",
      "requestSolicitPolicyContract",
      "requestSolicitApproveDraftContract",
      "requestSolicitDraftContract",
      "requestCancelQuotation",
      "requestAddChosenInsuranceInQuotation",
      "requestRefuseDrafContractQuotation",
      "requestDraftContractQuotation",
      "requestApproveDraftContractQuotation",
      "requestApprovalDraftContractQuotation",
      "requestEditCostQuotation",
      "requestDeclineCostQuotation",
      "requestItemsInsuranceToEmail",
      "requestRemoveDraftContractQuotation",
      "requestReactivateCostQuotation"
    ]),
    openRegistryWindow() {
      window
        .open(
          "https://www2.susep.gov.br/safe/menumercado/regapolices/pesquisa.asp",
          "_blank"
        )
        .focus();
    },
    updateHeaders() {
      this.headerDraft = this.hasItemDraft
        ? TABLE_HEADERS_WITH_DRAFT
        : TABLE_HEADERS_WITHOUT_DRAFT;
      if (
        this.quotation.apolice &&
        this.quotation.apolice.status_emissao.id == "apolice_emitida"
      )
        this.headerPolicy = TABLE_HEADERS_WITH_POLICY;
      this.headerBills =
        this.quotation?.apolice?.forma_pagamento?.id == "fatura"
          ? TABLE_HEADERS_BILLS_INVOICE
          : this.quotation?.apolice?.forma_pagamento?.id == "boleto"
          ? TABLE_HEADERS_BILLS_TICKET
          : TABLE_HEADERS_BILLS;
      this.fetchItemsInsurance();
    },
    closeModalGeneric(value) {
      this.modalGeneric = false;
      if (value && this.showCosts) {
        this.showCosts = false;
        this.updateHeaders();
      }
      if (value && this.changeInsurance) {
        this.showCosts = true;
        this.changeInsurance = false;
        this.textButtonGeneric = "OK";
      } else if (this.changeInsurance) {
        this.changeInsurance = false;
        this.textButtonGeneric = "OK";
      }
      if (this.isCancelQuotation) this.$router.push({ name: "quotation" });
    },
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    },
    openModalDetailsRefuseDraft() {
      this.modalDetails = true;
    },
    async submitRefuse(form) {
      this.modal = false;
      form.anexos = _.map(await this.submitFiles(form), "arquivo");
      this.withLoading(
        this.requestRejectDraftContract(this.getPayloadRefuse(form)).then(
          () => {
            this.titleGeneric = "RECUSA DE MINUTA ENVIADA";
            this.textGeneric =
              "Recusa de minuta enviada com sucesso.\nA cotação será cancelada.";
            this.modalGeneric = true;
          }
        )
      );
    },
    getPayloadRefuse(form) {
      return {
        id: this.$route.params.id,
        payload: form
      };
    },
    submitFiles(form) {
      const { uploadDocument } = this;
      return Promise.all(
        _.map(form.anexos, document =>
          documentAlreadyUploaded(document)
            ? Promise.resolve(document)
            : uploadDocument(document.arquivo[FILE], (file, arquivo) => ({
                arquivo
              }))
        )
      );
    },
    submit() {
      if (this.quotation.acoes.minuta.pode_enviar_seguradora) {
        this.modalInsuranceDetails = true;
      } else if (this.quotation.acoes.minuta.pode_aprovar) {
        this.withLoading(
          this.requestApproveDraftContract(this.$route.params.id).then(() => {
            this.titleGeneric = "APROVADA MINUTA";
            this.textGeneric = "Sua minuta foi aprovada com sucesso!";
            this.modalGeneric = true;
          })
        );
      } else if (this.quotation.acoes.minuta.pode_solicitar_aprovacao) {
        this.withLoading(
          this.requestSolicitApproveDraftContract(this.$route.params.id).then(
            () => {
              this.titleGeneric = "SOLICITAÇÃO DE APROVAÇÃO MINUTA";
              this.textGeneric = "Sua minuta foi enviada para aprovação!";
              this.modalGeneric = true;
            }
          )
        );
      } else if (this.quotation.acoes.apolice.pode_enviar_seguradora) {
        this.modalInsuranceDetails = true;
      }
    },
    closeModalDetails() {
      this.modalDetails = false;
    },
    closeInsuranceDetails() {
      this.modalInsuranceDetails = false;
    },
    async submitToInsurance(form) {
      this.modalInsuranceDetails = false;
      form.anexos = _.map(await this.submitFiles(form), "arquivo");
      if (this.quotation.acoes.minuta.pode_enviar_seguradora) {
        let payload = {
          payload: form,
          cotacao: this.$route.params.id,
          seguradora: this.quotation.minuta?.seguradora?.id
        };
        this.withLoading(
          this.requestSolicitDraftContract(payload).then(() => {
            this.modalGeneric = true;
            this.titleGeneric = "MINUTA SOLICITADA";
            this.textGeneric = "A minuta foi solicitada com sucesso.";
          })
        );
      } else {
        let payload = {
          payload: form,
          id: this.$route.params.id
        };
        this.withLoading(
          this.requestSolicitPolicyContract(payload).then(() => {
            this.titleGeneric = "APÓLICE EM EMISSÃO";
            this.textGeneric =
              "Emissão da apólice solicitada com sucesso!\nAguarde o retorno da seguradora.";
            this.modalGeneric = true;
          })
        );
      }
    },
    redirectCriticism() {
      this.$router.push({
        name: "quotation criticism",
        params: {
          id: this.$route.params.id
        }
      });
    },
    editItem() {
      if (this.quotation.minuta) {
        this.editDraftContract();
      } else {
        this.viewEditQuotation();
      }
    },
    changeViewToCost() {
      this.changeInsurance = true;
      this.modalGeneric = true;
      this.titleGeneric = "TROCAR SEGURADORA SEGURADORA";
      this.textGeneric = "Você realmente deseja trocar a seguradora?";
      this.textButtonGeneric = "SIM";
    },
    updateInsuranceCompany(item) {
      this.insuranceCompany = item;
    },
    viewEditQuotation() {
      this.$router.push({
        name: "edit quotation",
        params: { id: this.$route.params.id }
      });
    },
    editDraftContract() {
      this.$router.push({
        name: "quotation edit draft contract",
        params: { id: this.$route.params.id }
      });
    },
    previewItem(item) {
      window.open(item.arquivo ? item.arquivo.url : item.url);
    },
    async previewCertificates(item, i) {
      let { data } = await api.get(
        `/v1/seguradoras/documentos/${item.seguradora.id}`
      );
      window.open(data[i].arquivo_link, data[i].tipo_documento);
    },
    cancelQuotationButton() {
      this.modalCancel = true;
    },
    updateCostInQuotation() {
      this.withLoading(
        this.requestAddChosenInsuranceInQuotation({
          cotacao: this.$route.params.id
        }).then(() => {
          this.modalGeneric = true;
          this.titleGeneric = "COTAÇÃO SOLICITADA";
          this.textGeneric = "A cotação foi solicitada com sucesso.";
        })
      );
    },
    async submitRefuseDraftContract(form) {
      this.modalRefuse = false;
      form.anexos = await this.submitFiles(form);
      this.withLoading(
        this.requestRefuseDrafContractQuotation(
          this.getPayloadRefuseDraftContractQuotation(form)
        ).then(() => {
          this.titleGeneric = "RECUSA DE MINUTA ENVIADA";
          this.textGeneric =
            "Recusa de minuta enviada com para o Solicitante.\nAguarde uma nova emissão de minuta.";
          this.modalGeneric = true;
        })
      );
    },
    async submitRequestDraftContract() {
      let payload = {
        cotacao: this.$route.params.id,
        seguradora:
          this.insuranceCompany?.seguradora?.id ||
          this.quotation.minuta?.seguradora?.id
      };
      this.withLoading(
        this.requestDraftContractQuotation(payload).then(() => {
          this.modalGeneric = true;
          this.titleGeneric = "MINUTA SOLICITADA";
          this.textGeneric = "A minuta foi solicitada com sucesso.";
        })
      );
    },
    submitApproveDraftContract() {
      this.withLoading(
        this.requestApproveDraftContractQuotation(
          this.getPayloadNewCostInQuotation()
        ).then(() => {
          this.modalGeneric = true;
          this.titleGeneric = "MINUTA APROVADA";
          this.textGeneric =
            "A minuta foi aprovada e a emissão foi solicitada com sucesso.";
        })
      );
    },
    submitRequestApproveDraftContract() {
      this.withLoading(
        this.requestApprovalDraftContractQuotation(
          this.getPayloadNewCostInQuotation()
        ).then(() => {
          this.modalGeneric = true;
          this.titleGeneric = "SEGURADORA ESCOLHIDA";
          this.textGeneric = "A seguradora foi escolhida com sucesso.";
        })
      );
    },
    getPayloadNewCostInQuotation() {
      return {
        cotacao: this.$route.params.id,
        seguradora: this.insuranceCompany.seguradora.id
      };
    },
    closeModalCancelQuotation(value) {
      this.modalCancel = false;
      if (value.confirm)
        this.withLoading(
          this.requestCancelQuotation({ id: this.$route.params.id, justification: value.justification }).then(() => {
            this.modalGeneric = true;
            this.isCancelQuotation = true;
            this.titleGeneric = "COTAÇÃO CANCELADA";
            this.textGeneric =
              "A cotação foi cancelada com sucesso.\nVocê será redirecionado para lista de cotações.";
          })
        );
    },
    hasPolicyContractFile(item) {
      return item.arquivo == null;
    },
    openModalRefuseDraftContract() {
      this.modalRefuse = true;
    },
    closeModalRefuseDraftContract() {
      this.modalRefuse = false;
    },
    getPayloadRefuseDraftContractQuotation(form) {
      return {
        cotacao: this.$route.params.id,
        seguradora: this.insuranceCompany.seguradora.id,
        payload: form
      };
    },
    closeModalAdd() {
      this.modalAdd = false;
    },
    setCurrentFormDraftContract(form) {
      this.currentFormDraftContract = form;
      this.closeModalAdd(form);
    },
    editCostQuotation(item) {
      if (item.payload.alteracao_valor_premio) {
        this.modalChangedCost = true;
        this.payloadEditCost = item;
        this.statusPayload = "edit";
      } else {
        this.submitEditCostQuotation(item);
      }
    },
    submitEditCostQuotation(payload) {
      this.withLoading(
        this.requestEditCostQuotation(payload).then(() => {
          this.modalGeneric = true;
          this.titleGeneric = "CARD DE CUSTO ATUALIZADO";
          this.textGeneric =
            "O card de custo selecionado foi atualizado com sucesso.";
          !Object.prototype.hasOwnProperty.call(
            payload.payload,
            "exibir_cliente"
          ) && this.toggleCostUpdate(payload.seguradora);
          this.payloadEditCost = null;
          this.statusPayload = null;
        })
      );
    },
    submitDeclineCost(payload) {
      this.withLoading(
        this.requestDeclineCostQuotation(payload).then(() => {
          this.modalGeneric = true;
          this.titleGeneric = "CUSTO DECLINADO";
          this.textGeneric = "O custo selecionado foi declinado com sucesso.";
          this.toggleCostUpdate(payload.seguradora);
        })
      );
    },
    toggleCostUpdate(id) {
      this.costUpdatedToggle.toggle = !this.costUpdatedToggle.toggle;
      this.costUpdatedToggle.insuranceCompanyId = id;
    },
    openModalAdd(value) {
      this.formToModalDraftContract = _.cloneDeep(value);
      this.modalAdd = true;
    },
    closeInsuranceDetailsCost() {
      this.modalInsuranceDetailsCost = false;
    },
    openInsuranceDetailsCost() {
      this.modalInsuranceDetailsCost = true;
    },
    fetchItemsInsurance() {
      this.withLoading(
        this.requestItemsInsuranceToEmail(this.$route.params.id)
      );
    },
    closeModalUpdate(payload) {
      this.modalUpdate = false;
      this.payloadEditCost.payload.minuta = _.cloneDeep(payload);
      this.payloadEditCost.payload.minuta.valor = _.cloneDeep(
        this.payloadEditCost.payload.valor_premio
      );
      if (this.statusPayload === "edit") {
        this.submitEditCostQuotation(this.payloadEditCost);
      } else {
        this.submitReactivateCost(this.payloadEditCost);
      }
    },
    closeModalChangedCost(value) {
      this.modalChangedCost = false;
      if (value) {
        this.modalUpdate = true;
      } else {
        if (this.statusPayload === "edit") {
          this.submitEditCostQuotation(this.payloadEditCost);
        } else {
          this.submitReactivateCost(this.payloadEditCost);
        }
      }
    },
    submitRemoveDraftContract(item) {
      this.currentFormDraftContract = _.cloneDeep(item.minuta);
      this.currentFormDraftContract.arquivo = null;
    },
    submitReactivateCost(payload) {
      this.withLoading(
        this.requestReactivateCostQuotation(payload).then(() => {
          this.modalGeneric = true;
          this.titleGeneric = "CUSTO REATIVADO";
          this.textGeneric = "O custo selecionado foi reativado com sucesso.";
          !Object.prototype.hasOwnProperty.call(
            payload.payload,
            "exibir_cliente"
          ) && this.toggleCostUpdate(payload.seguradora);
          this.payloadEditCost = null;
          this.statusPayload = null;
        })
      );
    },
    reactivateCostQuotation(item) {
      if (item.payload.alteracao_valor_premio) {
        this.modalChangedCost = true;
        this.payloadEditCost = item;
        this.statusPayload = "reactivate";
      } else {
        this.submitReactivateCost(item);
      }
    }
  },
  props: {
    quotation: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.base-quotation-status__
  &footer
    border-top: 1px solid #D5D5E0 !important
    background: white !important
  &img
    width: 60% !important
  &button
    min-width: 40px !important
</style>
